import { render } from "./skeletonText.vue?vue&type=template&id=ce139c84"
import script from "./skeletonText.vue?vue&type=script&lang=js"
export * from "./skeletonText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__